var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 0H0.527344C0.236069 0 0 0.236069 0 0.527344V17.4727C0 17.7639 0.236069 18 0.527344 18H5.27344C5.56471 18 5.80078 17.7639 5.80078 17.4727C5.80078 16.3941 6.55183 15.4876 7.55859 15.2489V17.4727C7.55859 17.7639 7.79466 18 8.08594 18H17.4727C17.7639 18 18 17.7639 18 17.4727V0.527344C18 0.236069 17.7639 0 17.4727 0ZM16.9453 8.47266H9.52734V6.63794C11.1193 6.38429 12.3398 5.00208 12.3398 3.33984C12.3398 3.04857 12.1038 2.8125 11.8125 2.8125H9.52734V1.05469H16.9453V8.47266ZM8.47266 1.05469V3.33984C8.47266 3.63112 8.70872 3.86719 9 3.86719H11.2238C10.9851 4.87395 10.0786 5.625 9 5.625C8.70872 5.625 8.47266 5.86107 8.47266 6.15234V8.47266H6.15234V6.1875C6.15234 5.89622 5.91628 5.66016 5.625 5.66016C3.96277 5.66016 2.58055 6.88074 2.3269 8.47266H1.05469V1.05469H8.47266ZM13.7812 16.9453V11.8477C13.7812 11.5564 13.5452 11.3203 13.2539 11.3203C12.9626 11.3203 12.7266 11.5564 12.7266 11.8477V16.9453H8.61328V14.6602C8.61328 14.3689 8.37721 14.1328 8.08594 14.1328C6.42371 14.1328 5.04149 15.3534 4.78784 16.9453H1.05469V9.52734H2.8125C3.10378 9.52734 3.33984 9.29128 3.33984 9C3.33984 7.92142 4.0909 7.01491 5.09766 6.77623V9C5.09766 9.29128 5.33372 9.52734 5.625 9.52734H16.9453V16.9453H13.7812Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.dedb1269b6f90fb1fa950d6f89ad51e5.svg";
export { ForwardRef as ReactComponent };